// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.concierge-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 9998;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

.concierge-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.95);
  background: white;
  border-radius: 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  width: 380px;
  overflow: hidden;
  z-index: 9999;
  opacity: 0;
  animation: popIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: 0.1s;
  font-family: "Inter", sans-serif;
}
.concierge-popup.minimized {
  top: auto;
  bottom: 20px;
  right: 20px;
  left: auto;
  transform: none;
  width: 60px;
  height: 60px;
  border-radius: 30px;
}
.concierge-popup.minimized .concierge-content {
  display: none;
}
.concierge-popup.minimized .concierge-header {
  height: 100%;
  padding: 0;
}
.concierge-popup.minimized .concierge-header .logo-container {
  display: none;
}
.concierge-popup.minimized .concierge-header .close-btn {
  display: none;
}

.concierge-header {
  padding: 16px 20px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.concierge-header .header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.concierge-header .header-title {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.concierge-header .header-title span {
  font-size: 18px;
  font-weight: 600;
  color: #2C3E50;
  font-family: "Montserrat", sans-serif;
}
.concierge-header .contact-options {
  display: flex;
  gap: 8px;
}
.concierge-header .contact-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #F8F9FA;
  border-radius: 20px;
  font-size: 14px;
  color: rgb(0, 63, 114);
  font-weight: 500;
  transition: all 0.2s;
  cursor: pointer;
}
.concierge-header .contact-badge i {
  font-size: 14px;
}
.concierge-header .contact-badge:hover {
  background: #E9ECEF;
  transform: translateY(-1px);
}
.concierge-header .close-btn {
  background: none;
  border: none;
  color: #6C757D;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  transition: all 0.2s;
  font-size: 18px;
}
.concierge-header .close-btn:hover {
  background-color: #F8F9FA;
  color: #2C3E50;
  transform: rotate(90deg);
}

.concierge-content {
  padding: 24px;
}

.avatar-container {
  position: relative;
  width: 96px;
  height: 96px;
  margin: 0 auto 20px;
}
.avatar-container .avatar {
  width: 100%;
  height: 100%;
  border-radius: 48px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.avatar-container .status-indicator {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background-color: #28a745;
  border: 2px solid white;
  border-radius: 12px;
  padding: 3px 8px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  animation: pulse 2s infinite;
}
.avatar-container .status-indicator .status-text {
  color: white;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.concierge-message {
  text-align: center;
  margin-bottom: 28px;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.concierge-message h3 {
  color: #2C3E50;
  margin: 0 0 12px 0;
  font-size: 24px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}
.concierge-message p {
  color: #6C757D;
  margin: 0;
  font-size: 16px;
  opacity: 0;
  animation: fadeSlideUp 0.5s ease forwards;
}

.typing-container {
  min-height: 24px;
  display: flex;
  justify-content: center;
}

.typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 8px;
}
.typing-indicator span {
  width: 6px;
  height: 6px;
  background-color: rgb(0, 63, 114);
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}
.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}
.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-btn {
  width: 100%;
  padding: 16px;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
  background: #2C3E50;
  position: relative;
  overflow: hidden;
  text-align: left;
}
.action-btn .icon-container {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
}
.action-btn .icon-container i {
  font-size: 18px;
}
.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.action-btn:hover .icon-container {
  background: rgba(255, 255, 255, 0.25);
}
.action-btn:active {
  transform: translateY(0);
}
.action-btn.find-doctor {
  background: rgb(0, 63, 114);
}
.action-btn.learn-more {
  background: rgb(0, 63, 114);
}
.action-btn.cost-support {
  background: rgb(0, 63, 114);
}
.action-btn.chat {
  background: rgb(0, 155, 72);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes popIn {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ConciergePopup.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EAEA,0BAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;AACJ;;AAEA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,4DAAA;EACA,qBAAA;EACA,gCAAA;AACJ;AACI;EACI,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACR;AACQ;EACI,aAAA;AACZ;AAEQ;EACI,YAAA;EACA,UAAA;AAAZ;AAEY;EACI,aAAA;AAAhB;AAGY;EACI,aAAA;AADhB;;AAOA;EACI,uBAAA;EACA,4CAAA;AAJJ;AAMI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAJR;AAOI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AALR;AAOQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;AALZ;AASI;EACI,aAAA;EACA,QAAA;AAPR;AAUI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AARR;AAUQ;EACI,eAAA;AARZ;AAWQ;EACI,mBAAA;EACA,2BAAA;AATZ;AAaI;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAXR;AAaQ;EACI,yBAAA;EACA,cAAA;EACA,wBAAA;AAXZ;;AAgBA;EACI,aAAA;AAbJ;;AAgBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAbJ;AAeI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AAbR;AAgBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,4BAAA;AAdR;AAgBQ;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;AAdZ;;AAmBA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhBJ;AAkBI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;AAhBR;AAmBI;EACI,cAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,yCAAA;AAjBR;;AAqBA;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AAlBJ;;AAqBA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAlBJ;AAoBI;EACI,UAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,2CAAA;AAlBR;AAoBQ;EACI,uBAAA;AAlBZ;AAqBQ;EACI,uBAAA;AAnBZ;;AAwBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AArBJ;;AAwBA;EACI,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AArBJ;AAuBI;EACI,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,cAAA;AArBR;AAuBQ;EACI,eAAA;AArBZ;AAyBI;EACI,2BAAA;EACA,yCAAA;AAvBR;AAyBQ;EACI,qCAAA;AAvBZ;AA2BI;EACI,wBAAA;AAzBR;AA4BI;EACI,2BAAA;AA1BR;AA6BI;EACI,2BAAA;AA3BR;AA8BI;EACI,2BAAA;AA5BR;AA+BI;EACI,2BAAA;AA7BR;;AAiCA;EACI;IACI,UAAA;EA9BN;EAiCE;IACI,UAAA;EA/BN;AACF;AAkCA;EACI;IACI,UAAA;IACA,4CAAA;EAhCN;EAmCE;IACI,UAAA;IACA,yCAAA;EAjCN;AACF;AAoCA;EACI;IACI,0CAAA;EAlCN;EAqCE;IACI,0CAAA;EAnCN;EAsCE;IACI,wCAAA;EApCN;AACF;AAuCA;EAEI;IAGI,mBAAA;EAxCN;EA2CE;IACI,mBAAA;EAzCN;AACF;AA4CA;EACI;IACI,UAAA;IACA,2BAAA;EA1CN;EA6CE;IACI,UAAA;IACA,wBAAA;EA3CN;AACF","sourcesContent":[".concierge-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    -webkit-backdrop-filter: blur(2px);\n    backdrop-filter: blur(2px);\n    z-index: 9998;\n    opacity: 0;\n    animation: fadeIn 0.3s ease forwards;\n}\n\n.concierge-popup {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0.95);\n    background: white;\n    border-radius: 24px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n    width: 380px;\n    overflow: hidden;\n    z-index: 9999;\n    opacity: 0;\n    animation: popIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n    animation-delay: 0.1s;\n    font-family: 'Inter', sans-serif;\n\n    &.minimized {\n        top: auto;\n        bottom: 20px;\n        right: 20px;\n        left: auto;\n        transform: none;\n        width: 60px;\n        height: 60px;\n        border-radius: 30px;\n\n        .concierge-content {\n            display: none;\n        }\n\n        .concierge-header {\n            height: 100%;\n            padding: 0;\n\n            .logo-container {\n                display: none;\n            }\n\n            .close-btn {\n                display: none;\n            }\n        }\n    }\n}\n\n.concierge-header {\n    padding: 16px 20px 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n\n    .header-content {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .header-title {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n\n        span {\n            font-size: 18px;\n            font-weight: 600;\n            color: #2C3E50;\n            font-family: 'Montserrat', sans-serif;\n        }\n    }\n\n    .contact-options {\n        display: flex;\n        gap: 8px;\n    }\n\n    .contact-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        padding: 8px 12px;\n        background: #F8F9FA;\n        border-radius: 20px;\n        font-size: 14px;\n        color: rgb(0 63 114);\n        font-weight: 500;\n        transition: all 0.2s;\n        cursor: pointer;\n\n        i {\n            font-size: 14px;\n        }\n\n        &:hover {\n            background: #E9ECEF;\n            transform: translateY(-1px);\n        }\n    }\n\n    .close-btn {\n        background: none;\n        border: none;\n        color: #6C757D;\n        cursor: pointer;\n        width: 32px;\n        height: 32px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 16px;\n        transition: all 0.2s;\n        font-size: 18px;\n\n        &:hover {\n            background-color: #F8F9FA;\n            color: #2C3E50;\n            transform: rotate(90deg);\n        }\n    }\n}\n\n.concierge-content {\n    padding: 24px;\n}\n\n.avatar-container {\n    position: relative;\n    width: 96px;\n    height: 96px;\n    margin: 0 auto 20px;\n\n    .avatar {\n        width: 100%;\n        height: 100%;\n        border-radius: 48px;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n\n    .status-indicator {\n        position: absolute;\n        bottom: 4px;\n        right: 4px;\n        background-color: #28a745;\n        border: 2px solid white;\n        border-radius: 12px;\n        padding: 3px 8px;\n        display: flex;\n        align-items: center;\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        animation: pulse 2s infinite;\n\n        .status-text {\n            color: white;\n            font-size: 10px;\n            font-weight: 600;\n            letter-spacing: 0.5px;\n            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n        }\n    }\n}\n\n.concierge-message {\n    text-align: center;\n    margin-bottom: 28px;\n    padding: 0 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n    h3 {\n        color: #2C3E50;\n        margin: 0 0 12px 0;\n        font-size: 24px;\n        font-weight: 600;\n        font-family: 'Montserrat', sans-serif;\n    }\n\n    p {\n        color: #6C757D;\n        margin: 0;\n        font-size: 16px;\n        opacity: 0;\n        animation: fadeSlideUp 0.5s ease forwards;\n    }\n}\n\n.typing-container {\n    min-height: 24px;\n    display: flex;\n    justify-content: center;\n}\n\n.typing-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding-top: 8px;\n\n    span {\n        width: 6px;\n        height: 6px;\n        background-color: rgb(0 63 114);\n        border-radius: 50%;\n        display: inline-block;\n        animation: bounce 1.4s infinite ease-in-out;\n\n        &:nth-child(1) {\n            animation-delay: -0.32s;\n        }\n\n        &:nth-child(2) {\n            animation-delay: -0.16s;\n        }\n    }\n}\n\n.action-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.action-btn {\n    width: 100%;\n    padding: 16px;\n    border: none;\n    border-radius: 16px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    color: white;\n    background: #2C3E50;\n    position: relative;\n    overflow: hidden;\n    text-align: left;\n\n    .icon-container {\n        width: 36px;\n        height: 36px;\n        background: rgba(255, 255, 255, 0.15);\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s;\n        flex-shrink: 0;\n\n        i {\n            font-size: 18px;\n        }\n    }\n\n    &:hover {\n        transform: translateY(-2px);\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n\n        .icon-container {\n            background: rgba(255, 255, 255, 0.25);\n        }\n    }\n\n    &:active {\n        transform: translateY(0);\n    }\n\n    &.find-doctor {\n        background: rgb(0 63 114);\n    }\n\n    &.learn-more {\n        background: rgb(0 63 114);\n    }\n\n    &.cost-support {\n        background: rgb(0 63 114);\n    }\n\n    &.chat {\n        background: rgb(0 155 72);\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes popIn {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -48%) scale(0.95);\n    }\n\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1);\n    }\n}\n\n@keyframes pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n    }\n\n    70% {\n        box-shadow: 0 0 0 6px rgba(40, 167, 69, 0);\n    }\n\n    100% {\n        box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n    }\n}\n\n@keyframes bounce {\n\n    0%,\n    80%,\n    100% {\n        transform: scale(0);\n    }\n\n    40% {\n        transform: scale(1);\n    }\n}\n\n@keyframes fadeSlideUp {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
